import { ADVICE_STATUS } from 'constants/ChecklistConstants';
import {
  TYPES,
  STATUS,
  NOT_EXIST,
  AUDIT_STATUS,
  KIOSK_STATUS,
  CAMERA_STATUS,
  PAYMENT_TYPES,
  HARDWARE_STATUS,
  APPOINTMENT_TYPE,
  FOLLOW_UP_STATUS,
  CAMPAIGNS_STATUS,
  CAMPAIGN_FILES_STATUS,
  PAYMENT_PROGRESS_STATUS,
  formatNotExistRequestFilter,
} from 'constants/FilterConstants';
import { SELF_SERVICE_STATUS, SELF_SERVICE_TYPE } from 'constants/SelfServiceConstants';

import { ID_FILTER } from 'modules/global/reducers/filterSliceAdapter';

import { getSelfServiceStatus } from 'services/InterventionUtils';
import { createDictionary } from 'utils/ObjectUtils';

import { isSelfServiceStatusBelow } from './selfServiceStatus';

export const shouldResendSelfService = (selfService, newMobility) => {
  const status = getSelfServiceStatus(selfService);
  const reSendableStatus = !isSelfServiceStatusBelow(status, SELF_SERVICE_STATUS.SENT);

  if (selfService?.type === SELF_SERVICE_TYPE.CHECK_IN) {
    const { mobility: oldMobility } = selfService;
    return (
      reSendableStatus &&
      newMobility?.documents?.some(document => oldMobility?.documents?.every(({ id }) => document.id !== id))
    );
  }
  return false;
};

/**
 * @param {Record<import("@arhs-fleetback/types/entities/checklists").ChecklistAdviceStatus, import("@arhs-fleetback/types/entities/checklists").ChecklistAdviceStatus>} status
 * @returns {boolean}
 */
export const isAdviceAccepted = status =>
  [ADVICE_STATUS.ACCEPTED, ADVICE_STATUS.DEPOSIT_PAID, ADVICE_STATUS.PAID].includes(status);

export const isAdviceAnswered = status =>
  [ADVICE_STATUS.ACCEPTED, ADVICE_STATUS.DEPOSIT_PAID, ADVICE_STATUS.PAID, ADVICE_STATUS.REFUSED].includes(status);

export const REQUEST_FIELD_FORMATTER = {
  [PAYMENT_TYPES]: TYPES,
  [APPOINTMENT_TYPE]: TYPES,
  [AUDIT_STATUS]: STATUS,
  [KIOSK_STATUS]: STATUS,
  [CAMERA_STATUS]: STATUS,
  [HARDWARE_STATUS]: STATUS,
  [CAMPAIGNS_STATUS]: STATUS,
  [FOLLOW_UP_STATUS]: STATUS,
  [CAMPAIGN_FILES_STATUS]: STATUS,
  [PAYMENT_PROGRESS_STATUS]: STATUS,
};

const REQUEST_VALUE_FORMATTER = createDictionary({
  [NOT_EXIST]: formatNotExistRequestFilter,
}, value => value);

export const filterRequestFormatter = (filters = {}) =>
  Object.entries(filters).reduce((acc, [fieldValue, value]) => {
    const hasValue =
      (Boolean(value) || typeof value === 'boolean') &&
      (!Array.isArray(value) || (Array.isArray(value) && value.length > 0));

    const field = REQUEST_FIELD_FORMATTER[fieldValue] ?? fieldValue;
    const preformattedValue = ID_FILTER.includes(field) ? value.map(item => item.id) : value;

    return {
      ...acc,
      ...(hasValue
        ? {
          [field]: REQUEST_VALUE_FORMATTER[field](preformattedValue),
        }
        : {}),
    };
  }, {});
